import { FC } from "react";
import { CommonTable, ContentCell, LabelCell, NormalRow } from "../components/CommonTable";
import SummarySection from "../../../components/forms/SummarySection";
import { formatToDisplayQuoteReadableDate } from "../../../utils/date";
import CommonRow from "../../components/CommonRow";
import { proposerEventDetailsState } from "../bind/types";

type Props = {
  state: proposerEventDetailsState;
  editProposalDetailsLink: string;
  t: any;
};
const getCoverageDate = (date: Date | null) => {
  return date && formatToDisplayQuoteReadableDate(new Date(date));
};
const HkSummarySections: FC<Props> = ({ state, t }) => {
  return (
    <>
      <SummarySection name={t("SummaryLabels.proposerDetails")} link={"/event_public_liability/hk/bind/proposerDetails"}>
        <CommonTable className="w-full mt-2 table-fixed">
          <NormalRow>
            <ContentCell>{t("SummaryLabels.proposerName")}</ContentCell>
            <LabelCell>{state.proposerName}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.mobileNo")}</ContentCell>
            <LabelCell>{state.mobileNumber}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.email")}</ContentCell>
            <LabelCell>{state.email}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.uenNo")}</ContentCell>
            <LabelCell>{state.uenNumber}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.correspondenceAddress")}</ContentCell>
            <LabelCell>
              <p>
                {state.houseNumber} {state.streetName},
              </p>
              <p>
                {state.building} {state.district} {state.territory} {t("countryName")}
              </p>
            </LabelCell>
          </NormalRow>
        </CommonTable>
      </SummarySection>
      <SummarySection name={t("SummaryLabels.coverage")} link={"/event_public_liability/hk/bind/eventDetails"}>
        <CommonTable className="w-full mt-2 table-fixed">
          <NormalRow>
            <ContentCell>{t("SummaryLabels.eventName")}</ContentCell>
            <LabelCell>{state.eventTitle}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.eventAddress")}</ContentCell>
            <LabelCell>
              <p>
                {state.eventHouseNumber} {state.eventStreetName},
              </p>
              <p>
                {state.eventDistrict} {state.eventTerritory} {t("countryName")}{" "}
              </p>
            </LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.limitperOccurrence")}</ContentCell>
            <LabelCell>
              {t("SummaryLabels.currency")} {state.limit}
            </LabelCell>
          </NormalRow>
          <NormalRow>
            {/* Display periodofCoverage */}
            <ContentCell>{t("SummaryLabels.periodofCoverage")}</ContentCell>
            <LabelCell>
              {getCoverageDate(state.coverageStartDate)} - {getCoverageDate(state.coverageEndDate)} {t("SummaryLabels.bothDaysInclusive")}
            </LabelCell>
          </NormalRow>
          {state.additionalInsured === "yes" ? (
            <>
              {/* Display Landlord and Principal values when additionalInsured is yes */}
              <div className="whitespace-pre-line">
                <CommonRow label={t("SummaryLabels.additionalInsuredLandlord")} value={state.landlord} />
              </div>
              <div className="whitespace-pre-line">
                <CommonRow label={t("SummaryLabels.additionalInsuredPrincipal")} value={state.principal} />
              </div>
            </>
          ) : (
            <NormalRow>
              <ContentCell>{t("SummaryLabels.additionalInsured")}</ContentCell>
              <LabelCell>{"-"}</LabelCell>
            </NormalRow>
          )}
        </CommonTable>
      </SummarySection>
    </>
  );
};

export default HkSummarySections;
